import { UTCDate } from '@date-fns/utc';
import { endOfMonth } from 'date-fns';
import type { PlayersLeaderboardDtoPaginatedList } from '@/api/backoffice-schemas';
import type { PoweredBy } from '@/types/sponsor';
import { CountdownCard, SponsorCard, TopWinnerCards } from './TopWinnersCard';

export const PickemsLeaderboardTopWinners = ({
  data,
  poweredBy,
}: {
  data: PlayersLeaderboardDtoPaginatedList;
  poweredBy: PoweredBy;
}) => {
  const items = data?.items ?? [];
  const players = items.map((item) => ({
    userName: item.user?.userName ?? undefined,
    points: item.points,
  }));
  const countdownDatetime = endOfMonth(new UTCDate());

  return (
    <div className="mb-5 rounded-lg bg-custom-gradient-2 px-4 py-4 md:px-8 md:py-16 lg:px-32">
      <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:gap-8">
        <div className="w-full md:w-auto">
          <SponsorCard poweredBy={poweredBy} />
        </div>
        <div className="w-full md:w-auto">
          <CountdownCard
            countdownDatetime={countdownDatetime}
            countdownLabel="Monthly leaderboard reset in:"
          />
        </div>
      </div>

      {players.length === 0 ? (
        <p className="py-24 text-center font-semibold text-lg text-white md:py-48 md:text-xl">
          No winners at the moment. Check back later to see the top players.
        </p>
      ) : (
        <TopWinnerCards players={players} />
      )}
    </div>
  );
};
